
<link rel="stylesheet" [href]='cssUrlBootStrap'>
<link rel="stylesheet" [href]='cssUrlCustomStyle'>
<!--<link rel="stylesheet" [href]='cssUrlCustom'>-->
<link rel="stylesheet" [href]='cssUrlfontawesome'>
<link rel="stylesheet" [href]='cssUrlDatePicker'>
<!--<link rel="stylesheet" [href]='cssUrlCustomce'>-->
<link rel="stylesheet" [href]='cssUrlCleanCustom'>
@if (isIE11Browser) {
  <link rel="stylesheet" [href]='cssUrlIEStyles' type="text/css">
}
<!--<link rel="stylesheet" [href]='cssStyle'>-->
<link rel="stylesheet" [href]='cssSwitchery'>
<!--[loadingText]="'Processing.Please wait...'"-->
<app-toastr-notification></app-toastr-notification>
<ngx-spinner bdColor="rgba(0,0,0,0.6)" [fullScreen]="true">
  <div class="center spinner ">
    <div class="loader-container">
      <div class="loader-logo">
        <div class="loader-circle"></div>
      </div>
    </div>
  </div>
</ngx-spinner>
<ng2-slim-loading-bar [color]="'#f15a29'" [height]="'6px'"></ng2-slim-loading-bar>


<router-outlet></router-outlet>

<div bsModal #ConfirmLogoutModal="bs-modal" class="modal fade timeout-modal logout-modal" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static',keyboard:false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"> {{'Messages.SessionAbouttToExpire' | translate}} </h4>
      </div>
      <div class="modal-body">
        <!--<div class="form-horizontal">-->
        <div class="form-group row ml-3 mr-3">
          <div class="col-md-12">
            <p>{{'Messages.SessionLockMessage' | translate}} {{timerCount}} {{'Messages.SessionDurationSecond' | translate}}.{{'Messages.Doyouwanttocontinue' | translate}}</p>
          </div>

        </div>
        <div class="form-group row" style="margin-bottom: 0rem !important">
          <div class="col-md-12">
            <div class="action modal-footer">
              <button type="button" class="btn btn-light" (click)="logout()">{{'Messages.NoLogout' | translate}}</button>
              <button type="button" class="btn btn-primary" (click)="keepWorking()">{{KeepWorkingButtonText | translate}}</button>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
  </div>
</div>
</div>

<div bsModal #RefreshTokenFaildedModal="bs-modal" class="modal fade timeout-modal refreshtoken-failed-modal" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static',keyboard:false}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"> {{'Messages.RefreshTokenFailed' | translate}} </h4>
      </div>
      <div class="modal-body">
        <!--<div class="form-horizontal">-->
        <div class="form-group row ml-3 mr-3">
          <div class="col-md-12">
            @if (!hideKeepWorkingButton) {
              <p><b> {{'Messages.RefreshTokenFailedDesc'  | translate}} </b></p>
            }
            @if (!hideKeepWorkingButton) {
              <p>{{'Messages.SessionLockMessage' | translate}} {{refreshTokenFailedtimerCount}} {{'Messages.SessionDurationSecond' | translate}}.{{'Messages.Doyouwanttocontinue' | translate}}</p>
            }
            @if (hideKeepWorkingButton) {
              <p class="text-danger center"><b>
                {{'Messages.SessionLogoutMessage' | translate}}
              </b>
            </p>
          }
        </div>

      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <div class="action modal-footer">
            <button type="button" class="btn btn-light" (click)="logout()">{{logOutButtonText| translate}}</button>
            @if (!hideKeepWorkingButton) {
              <button  type="button" class="btn btn-primary" (click)="ManuallTokenRefresh()"> {{KeepWorkingButtonText | translate}}</button>
            }
          </div>
        </div>
      </div>
    <!--</div>-->
  </div>
</div>
</div>
</div>



